module.exports = __webpack_public_path__ + "media/images/application/icons/linkedin-logo-f65bfce74dd408a1903ef7d6a6bec573.svg";